const STARTING_HOOK = {
  'data-starting-style': ''
};
const ENDING_HOOK = {
  'data-ending-style': ''
};
export const transitionStatusMapping = {
  transitionStatus(value) {
    if (value === 'starting') {
      return STARTING_HOOK;
    }
    if (value === 'ending') {
      return ENDING_HOOK;
    }
    return null;
  }
};